
<template>
	<div>
		<TopNav/>
		<div class="container">
			<div class="columns">
				<div id="main" class="column">
			<!-- End Profile header -->
			<section class="login">
			<div class="columns">
				<div class="column">
					<form class="is-maxed">
						<h1>Change Password</h1>
                        <p>Please your new password. You will be able to login with it after completing this form.</p>
						<div class="field is-maxed">
							<label class="label">New Password</label>
							<p class="control has-icons-left is-expanded">
								<input class="input is-small "  
									@change="checkNewPassword" :class="{'is-danger': errors.newPassword}"
									v-model.trim="newPassword"
									type="password" placeholder="Password">
								<span class="icon is-small is-left">
								<i class="fa fa-lock"></i>
								</span>
							</p>
						</div>
						<p class="help is-danger" v-if="errors.newPassword">
							{{ errors.newPassword }}
						</p>
						<div class="field is-maxed">
							<label class="label">Confirm New Password</label>
							<p class="control has-icons-left is-expanded">
								<input class="input is-small "  
									@change="checkConfirmPassword" :class="{'is-danger': errors.confirmPassword}"
									v-model.trim="confirmPassword"
									type="password" placeholder="Password">
								<span class="icon is-small is-left">
								<i class="fa fa-lock"></i>
								</span>
							</p>
						</div>
						<p class="help is-danger" v-if="errors.confirmPassword">
							{{ errors.confirmPassword }}
						</p>
						<div class="field is-maxed">
							<div class="control">
								<a class="button is-small is-link" @click.prevent="savePassword()">Submit</a>
							</div>
						</div>
					</form>
				</div>
			</div>
			</section>
		</div>
			</div>
		<div class="columns is-paddingless">
	<div class="column is-paddingless">
		<div class="footer">
			<div class="container">
				<div class="columns">
					<div class="column">
						<p>
							©Copyright 2020 Psychic Portal. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
		</div>
	</div>
</template>

<script>
	import TopNav from "../TopNav.vue"

	export default {
		components: {
			TopNav
		},
		data() {
			return {
				newPassword: "",
				confirmPassword: "",
				errors: {
					newPassword: null,
					confirmPassword: null,
				}
			}
		},
		methods: {
			checkNewPassword() {
				this.errors.newPassword = null
				if (this.newPassword === "") {
					this.errors.newPassword = "Password is required"
				} else if (this.newPassword.length < 6 || this.newPassword.length > 50) {
					this.errors.newPassword = "Password is invalid"
				}

				return this.errors.newPassword === null
			},
			checkConfirmPassword() {
				this.errors.confirmPassword = null
				if (this.confirmPassword === "") {
					this.errors.confirmPassword = "Password Confirmation is required"
				} else if (this.confirmPassword !== this.newPassword) {
					this.errors.confirmPassword = "Passwords do not match"
				}

				return this.errors.confirmPassword === null
			},
			async savePassword() {
				if (this.checkNewPassword() && this.checkConfirmPassword()) {
					await this.$root.$data.setters.updatePasswordUnchecked(this.$root.$data.state, {
						password: this.newPassword,
					})
					this.$notify({
						group: 'global',
						type: 'success',
						title: 'Password Updated',
						text: 'Your password has been updated.',
					})
					this.$router.push("/login")
				}			
			}
		},
		async mounted() {
			try {
				await this.$root.$data.getters.authorizePassword(this.$root.$data.state, this.$route.params["uuid"])
			} catch(e) {
				this.$notify({
					group: 'global',
					type: 'error',
					title: 'Link Expired',
					text: 'This Forgot Password link is no longer valid.',
				})
			}
		}
	}
</script>